import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

function ServiceWorkerWrapper() {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [registrationWaiting, setRegistrationWaiting] = useState(null);

    // ثبت Service Worker
    serviceWorkerRegistration.register({
        onUpdate: (registration) => {
            if (registration && registration.waiting) {
                setRegistrationWaiting(registration.waiting);
                setUpdateAvailable(true);
            }
        },
    });

    const handleUpdate = () => {
        if (registrationWaiting) {
            registrationWaiting.postMessage({type: "SKIP_WAITING"});
            window.location.reload();
        }
    };

    const handleClose = () => {
        handleUpdate(); // چه کاربر دیالوگ رو ببنده، چه دکمه بزنه → ریفرش
    };

    return (
        <Dialog
            open={updateAvailable}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>نسخه جدید در دسترس است</DialogTitle>
            <DialogContent>
                <Typography>
                    نسخه جدیدی از اپلیکیشن منتشر شده است. برای استفاده از امکانات جدید، لطفاً صفحه را بروزرسانی کنید.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleUpdate} color="primary" autoFocus>
                    بروزرسانی
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ServiceWorkerWrapper;
